import React, { useState, useRef, useEffect } from "react";
import useStyles from "isomorphic-style-loader/useStyles";
import classes from "./style.module.scss"
import withEL from "../../../../../hocs/el-scroll"
import { useSelector } from "react-redux";
import { Swiper, SwiperSlide } from 'swiper/react';
import { useWebp } from "../../../../../hooks/common";
import { IMAGE_GEEKO_LTD } from "../../../../../../constants";
import ReactPlayer from "react-player/lazy"
import { LazyLoadImage } from "react-lazy-load-image-component";
import ProductShopSimlar from "../../../module/search-image/shop-simlar/index"
import ProductAlertImage from "../../../module/search-image/index"
import { Iconfont } from "../../../../../components/icon/iconfont";
import ProductShare from "../../product-share";

const ELElement = withEL(props => {
    return <div ref={props.innerRef} {...props}>
        {props.children}
    </div>
})

const ProductImageSwiper = props => {
    useStyles(classes);
    const { product, shopTheLookData, showPromotionImage } = props;
    const [imageIndex, setImageIndex] = useState(1);
    const [showPlayer, setShowPlayer] = useState(false);
    const [maskShow, setMaskShow] = useState(false);
    const [muted, setMted] = useState(true);
    const playerRef = useRef(null);
    const [selectImage, setSelectImage] = useState(null);
    const pageProduct = useSelector((state) => state.pageProduct);
    const [showShareModal, setShowShareModal] = useState(false)
    const global = useSelector(state => state.global);
    const { config } = global;

    const isWebp = useWebp() && product?.status === '1'

    let images = [product?.pcMainImage, ...(product?.pcExtraImageUrls || [])];

    useEffect(() => {
        if (product?.listingVideoLink && window.GeekoSensors) {
            window.GeekoSensors.Track('VideoExpose', {
                is_success: true,
            })
        }
    }, []);

    const youtubePlayEvent = () => {

        setShowPlayer(true);

        if (window.GeekoSensors) {
            window.GeekoSensors.Track('VideoClick', {
                is_success: true,
            })
        }
    }

    const imageHandle = (image, index) => {
        setSelectImage(image);
    }

    const videoMuted = () => {
        // let playerItem = playerRef.current?.getInternalPlayer();

        // if (playerItem.isMuted()) {
        //     setMted(false);
        //     // playerItem.unMute();
        // } else {
        //     setMted(true);
        //     // playerItem.mute()
        // }
        setMted(!muted)
    }


    const imagePrefix = `${IMAGE_GEEKO_LTD}${isWebp ? '/webp' : ''}`
    // product.listingVideoLink="https://image.geeko.ltd/video/965955c2-ec8c-4160-a1bb-99fb73b0b6ed"
    // product.listingVideoLink="https://www.youtube.com/watch?v=DyaiSb3zCvk"
    return <>
        {
            product ?
                <Swiper
                    spaceBetween={5}
                    slidesPerView='auto'
                    onSlideChange={(swiper) => setImageIndex(swiper.realIndex + 1)}
                    onSwiper={(swiper) => console.log()}
                    className={classes.SwiperBox}
                >
                    {
                        images?.map((item, index) => {
                            return product?.listingVideoLink && (index === 0) ? (
                                <SwiperSlide key={index + product?.listingVideoLink} style={{ width: 'auto' }}>
                                    <div className={`${classes.ProductImageSlide} ${classes.ProductYoutubeImage}`} onClick={() => youtubePlayEvent()}>
                                        <LazyLoadImage src={`${IMAGE_GEEKO_LTD}/large/${item}`} alt={`${product?.parentSku}-${index}`} />
                                        {
                                            showPlayer && <React.Fragment>
                                                <ReactPlayer className={classes.Player}
                                                    ref={playerRef}
                                                    width='100%'
                                                    height='100%'
                                                    url={product?.listingVideoLink}
                                                    muted={muted}
                                                    loop
                                                    volume={0.5}
                                                    playing={showPlayer}
                                                    onStart={() => { setMaskShow(true) }}
                                                    config={{
                                                        youtube: {
                                                            playerVars: { showinfo: 0, controls: 0, modestbranding: 1, playsinline: 1, autohide: 1, rel: 0, iv_load_policy: 3 },
                                                            embedOptions: { showinfo: 0, controls: 0, modestbranding: 1, playsinline: 1, autohide: 1, rel: 0, iv_load_policy: 3 }
                                                        }
                                                    }}
                                                />
                                            </React.Fragment>
                                        }

                                        <img className={classes.BoFangBtn} src={`${IMAGE_GEEKO_LTD}/chicme/20211102/bofang_whiate.png`} alt="Bo Fang"></img>

                                        {
                                            maskShow && <React.Fragment>
                                                <div className={classes.BoFangMask}></div>
                                                <span className={`${classes.YoutubeMuted} ${!muted ? classes.Active : ""}`} onClick={videoMuted}></span>
                                            </React.Fragment>
                                        }
                                    </div>
                                </SwiperSlide>
                            ) : (
                                <SwiperSlide key={index + item} onClick={() => imageHandle(item, index)} style={{ width: 'auto' }}>
                                    <ELElement className={classes.ProductImageSlide} data-content={`${imagePrefix}/large/${item}`} data-type="pic" data-position={index + 1} data-sku={product?.parentSku}>
                                        {
                                            index === 0 ?
                                                (<img src={`${imagePrefix}/large/${item}`} alt={`${product?.name}`} />) :
                                                (<LazyLoadImage src={`${imagePrefix}/large/${item}`} alt={`${product?.parentSku}-${index}`} />)
                                        }
                                    </ELElement>
                                </SwiperSlide>
                            )
                        })
                    }

                    <span className={classes.PproductShare} onClick={() => {
                        setShowShareModal(true);

                        if (window.GeekoSensors) {
                            window.GeekoSensors.Track('ClickShareProduct', {
                                product_id: product?.id,
                                share_channel: "entrance",
                            })
                        }
                    }}>
                        <Iconfont>&#xe7ed;</Iconfont>
                    </span>

                    <span className={classes.PproductImageCount}>
                        <span>{imageIndex}</span>/<span>{images?.length}</span>
                    </span>

                    {/* <ProductShopSimlar className={showPromotionImage?classes.ShopSimilar:""} image={images?.[imageIndex-1]} productId={product?.id} showShopTheLook={!!shopTheLookData} openShopTheLookMask={props?.openShopTheLookMask}/> */}

                    {/* {
                        product?.icon1 && <img style={{ width: '50px', position: 'absolute', top: 0, left: 0, zIndex: 2 }} src={product?.icon1} alt="Icon1" />
                    } */}

                    {
                        selectImage && <ProductAlertImage
                            productId={product?.id}
                            images={[product?.pcMainImage, ...(product?.pcExtraImageUrls || [])]}
                            selectedImage={selectImage}
                            onClose={() => setSelectImage(null)}
                        />
                    }

                </Swiper> :
                <div>
                    222
                </div>
        }

        <ProductShare
            showShareModal={showShareModal}
            onClose={() => setShowShareModal(false)}
            fetchParams={{ urlCode: "P01D", params: JSON.stringify({ productId: product?.id }) }}
            sharePrefix={`${config?.name} ${product?.name} `}
            shareImageurl={`${IMAGE_GEEKO_LTD}/large/${product?.id}`}
            productId={product?.id}
            isSensor
        />
    </>
}

export default ProductImageSwiper; 